module.exports = __webpack_public_path__ + "img/IMG_3450_L_WoodMatted_MockedUp.84b079f4.jpg";